module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M37.8761 2.13333H2.12389V37.8667H37.8761V2.13333ZM0 0V40H40V0H0Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M33.4231 6.6039H24.0769V15.8961H33.4231V6.6039ZM22 4.5V18H35.5V4.5H22Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M22 22H35.5V35H33.4231V24.0526H24.0769V35H22V22Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M4.5 22H18V35H15.9231V24.0526H6.57692V35H4.5V22Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M18.3785 18.1034L18.3785 20L20.5 20L20.5 16.0345L18.2901 16.0345L18.2901 5L16.1685 5L16.1685 16.0345L6.62155 16.0345L6.62155 5L4.5 5L4.5 18.1034L18.3785 18.1034Z",
      "fill": "black"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c63f8e32","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/logo.vue
// module id = 00ea0c6b827f0637e8c2
// module chunks = 89